'use client';

import { OptimizelyProvider } from 'providers/OptimizelyProvider';
import { useState } from 'react';
import { AdProvider } from '@/app_lib/providers/AdProvider';
import type { PageAdConfig } from '@/app_lib/types/Ad';

export const AdOptimizelyProvider = ({
  children,
  hasLoggedIn,
}: {
  children: React.ReactNode;
  hasLoggedIn: boolean;
}) => {
  const [pageAdConfig, setPageAdConfig] = useState<PageAdConfig | undefined>();

  return (
    <OptimizelyProvider pageAdConfig={pageAdConfig}>
      <AdProvider
        hasLoggedIn={hasLoggedIn}
        pageAdConfig={pageAdConfig}
        setPageAdConfig={setPageAdConfig}
      >
        {children}
      </AdProvider>
    </OptimizelyProvider>
  );
};
